import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/resources")({
  pendingComponent: PagePending,
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: "Resources",
  }),
  head: () => ({
    meta: seo({ title: "Resources" }),
  }),
});
